'use strict'

exports.OFFLINE_ERROR = new Error('This command must be run in online mode. Try running \'ipfs daemon\' first.')



//////////////////
// WEBPACK FOOTER
// ./~/ipfs/src/core/utils.js
// module id = 136
// module chunks = 0